<template>
  <v-app :class="{ [backgroundColor]: true }">
    <app-drawer />
    <app-toolbar />
    <v-content> <router-view /> </v-content>
  </v-app>
</template>

<script>
import AppDrawer from "./components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import { SET_DATA } from "@/action-types";
import axios from "axios";
import { seoUrl } from "@/utils/StringUtils";

export default {
  name: "App",
  components: { AppToolbar, AppDrawer },
  computed: {
    toolbar() {
      return this.$store.state.toolbar;
    },
    backgroundColor() {
      return this.toolbar.background || "white";
    }
  },
  data() {
    return {
      drawer: false
    };
  },
  async created() {
    const data = await axios.get("/data.json").then(response =>
      response.data.map((recipe, index) => ({
        ...recipe,
        url: seoUrl(recipe.heading),
        order: index
      }))
    );
    this.$store.commit(SET_DATA, data);
  }
};
</script>
